import { Layout } from '@/components/layout';
import { ProfileCreationOutlet } from '@/contexts/profile-creation-context';
import { PatientInformationPage } from '@/pages/patient-information/patient-information-page';
import { CreateProfileReviewPage } from '@/pages/profile-creation/create-profile-review-page';
import { PatientDemographics } from '@/pages/profile-creation/patient-demographics';
import { ProfileSetupPage } from '@/pages/profile-creation/profile-setup-page';
import { CreateProfileSurrogatePage } from '@/pages/surrogate/create-profile-surrogate-page';
import { Outlet, Route } from '@/util/react-router-dom';

export const profileCreationRoutes = (
  <Route element={<Layout simplified />}>
    <Route path="profile" element={<Outlet />}>
      <Route element={<ProfileCreationOutlet />}>
        <Route path="type-selection" element={<ProfileSetupPage />} />
        <Route path="patient-info" element={<PatientDemographics mode="create" />} />
        <Route path="surrogate" element={<CreateProfileSurrogatePage mode="create" />} />
        <Route path="review" element={<CreateProfileReviewPage />} />
        <Route path="edit-patient-info" element={<PatientDemographics mode="edit" />} />
        <Route path="edit-surrogate" element={<CreateProfileSurrogatePage mode="edit" />} />
      </Route>
      <Route path="information" element={<PatientInformationPage />} />
    </Route>
  </Route>
);
